export default __webpack_public_path__ + "static/media/reach-logo.2f5d07d5.svg";